import { Compass, Map as MapIcon, Navigation, Globe } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useAuth } from "@/context/AuthContext";
import { googleNavUrl, wazeNavUrl, appleNavUrl, osmWebUrl, openUrl } from "@/lib/geo";

// Sélecteur d'application de navigation : Plans / Google Maps / Waze (+ secours carte web).
// Liens universels : app native si installée, version web sinon — jamais bloquant.
export const NavChooser = ({ geo, onClose }) => {
  const { t } = useAuth();

  if (!geo) return null;

  const apps = [
    { key: "google", label: "Google Maps", icon: Navigation, url: () => googleNavUrl(geo), testid: "nav-open-google" },
    { key: "waze", label: "Waze", icon: Compass, url: () => wazeNavUrl(geo), testid: "nav-open-waze" },
    { key: "apple", label: t("agd.nav_apple"), icon: MapIcon, url: () => appleNavUrl(geo), testid: "nav-open-apple" },
  ];

  return (
    <Dialog open={!!geo} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="card-bg border-app max-w-sm" data-testid="nav-chooser-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">{t("agd.nav_choose")}</DialogTitle>
        </DialogHeader>
        {(geo.name || geo.address) && (
          <p className="text-xs t-secondary -mt-1 truncate" data-testid="nav-chooser-destination">
            {geo.name || geo.address}
          </p>
        )}
        <div className="space-y-2 mt-1">
          {apps.map((a) => (
            <button
              key={a.key}
              onClick={() => { openUrl(a.url()); onClose(); }}
              className="w-full flex items-center gap-3 border border-app rounded-xl px-4 py-3.5 hover:bg-white/5 transition-colors text-left"
              data-testid={a.testid}
            >
              <a.icon className="h-5 w-5 accent shrink-0" />
              <span className="text-sm font-medium">{a.label}</span>
            </button>
          ))}
        </div>
        <button
          onClick={() => { openUrl(osmWebUrl(geo)); onClose(); }}
          className="w-full text-xs t-secondary hover:text-white transition-colors flex items-center justify-center gap-1.5 pt-1"
          data-testid="nav-open-osm"
        >
          <Globe className="h-3.5 w-3.5" /> {t("agd.nav_web")}
        </button>
      </DialogContent>
    </Dialog>
  );
};
